export const C = {
  bg: "#080909",
  surface: "rgba(255,255,255,0.033)",
  surfaceHover: "rgba(255,255,255,0.06)",
  border: "rgba(255,255,255,0.08)",
  borderHover: "rgba(255,255,255,0.18)",
  gold: "#F5C518",
  goldDim: "rgba(245,197,24,0.13)",
  goldBorder: "rgba(245,197,24,0.28)",
  text: "#EFEFEF",
  muted: "rgba(255,255,255,0.38)",
  success: "#4CAF7D",
  danger: "#FF5252",
};

export const STEPS = [
  { id: 1, icon: "◈", label: "Profilo" },
  { id: 2, icon: "◉", label: "Esperienza" },
  { id: 3, icon: "◎", label: "Formazione" },
  { id: 4, icon: "◆", label: "Competenze" },
  { id: 5, icon: "▣", label: "Download" },
];
